import EventBus from '@/event-bus';
import _Singleton, { deferredSingletonExport } from '@/tools/singleton';
import cookie from '@/tools/get-cookie';
import createStorage from '@/storage';
const Store = createStorage({ name: 'compare' });
import domReady from '@/tools/domReady';
import _findIndex from 'lodash/findIndex';
import _toString from 'lodash/toString';
import ajax from '@/ajax/compare';

/**
 * Сравнение товаров
 * @class
 */
let Compare = function (options) {
  options = options || {};

  let self = this;

  self.products = [];
  self.maxItems = options.maxItems || 4;

  // Обновляемся
  domReady(function () {
    self._update();
  });
};

/**
  * Убираем работу с ajax в отдельный метод
  * @method
  *
  * @param {string}  - задача
  * @param {Object} task- товар
*/
Compare.prototype._doAjax = function (methodName, task) {
  let self = this;

  ajax[methodName](task.item)
    .done(function (response) {
      self.products = response.products;
      self._events(task);
    })
    .fail(function (response) {
      console.warn('fail: ', response);
    })
    .always(function () {
      self._always(task);
    });
};

/**
* Добавляем товар
* @method
*
* @param {Object} task - задача
* @param {number} task.item - id товара, добавляемого в сравнение
*
* @fires before:insales:compares
* @fires overload:insales:compares
* @fires in_list:insales:compares
* @fires add_item:insales:compares
* @fires always:insales:compares
*
* @example
* Compare.add({ item: 123456 });
*/
Compare.prototype.add = function (task) {
  let self = this;

  task.item = parseInt(task.item);
  task.method = 'add_item';

  // если достигли максимального кол-ва товаров
  // кидаем остановку
  if (self.products.length >= self.maxItems) {
    task.method = 'overload';
    self._events(task);
    self._always(task);

    return;
  }
  else if (_findIndex(self.products, task.item) != -1) {
    task.method = 'in_list';
    self._events(task);
    self._always(task);

    return;
  }
  self._before(task);
  self._doAjax('add', task);
};


/**
* Удаляем товар из сравнения
* @method
*
* @param {Object} task - задача
* @param {number} task.item - id товара, добавляемого в сравнение
*
* @fires before:insales:compares
* @fires remove_item:insales:compares
* @fires update_items:insales:compares
* @fires always:insales:compares
*
* @example
* Compare.remove({item: 123456});
*/
Compare.prototype.remove = function (task) {
  let self = this;

  task.item = parseInt(task.item);
  task.method = 'remove_item';

  self._before(task);
  self._doAjax('remove', task);
};

/**
* Очищаем сравнение
* @method
*
* @fires before:insales:compares
* @fires update_items:insales:compares
* @fires always:insales:compares
*
* @example
* Compare.clear();
*/
Compare.prototype.clear = function () {
  let self = this;
  let task = { item: [] };

  task.method = 'clear';

  self._before(task);
  self._doAjax('clear', task);
};

/**
 * Обновляем состояние сравнения
 * @method
 *
 * @fires before:insales:compares
 * @fires update_items:insales:compares
 * @fires always:insales:compares
 *
 * @example
 * Compare.update();
 */
Compare.prototype.update = function () {
  let self = this;

  self._update({ method: 'update_items' });
};

/**
 * Получение текущего состояния Сравнения
 * @method
 *
 * @return {Object} Объект, описывающий состояние и настройки сравнения
 *
 * @example
 * Compare.getCompare();
 */
Compare.prototype.getCompare = function () {
  let self = this;

  return self;
};

/**
 * Получение актуальной инфы с сервера
 * @method
 * @private
 *
 * @param {Object} task - задача
 * @param {string} task.method - название метода. Объязательно. Иначе мы делаем инициализацию сущности.
 */
Compare.prototype._update = function (task) {
  let self = this;

  task = task || {};
  task.method = task.method || 'init';
  if (task.method == 'init' || task.method == 'update_items') {
    self._before(task);
  }

  Store.getItem('compare')
    .then(function (compareAtStore) {
      let _insOVCached = compareAtStore || '';

      let compareCookie = cookie('compare_v2') || '';
      // создаем новый  массив с одними id для сравнения с кукой
      let transformCashed = [];
      // Добавляем только нужное в массив для сравнения

      for (let i = 0; i < _insOVCached.length; i++) {
        transformCashed.push(_insOVCached[i].id);
      }

      // делаем куку валидной для сравнения, удаляем квадратные скобки по бокам
      compareCookie = compareCookie.split('').slice(1, -1).join('');
      // Сравниваем, если равны то уходим нафиг вообще отсюда, и прокидываем в events, чтобы он ничего не делал.
      if (_toString(transformCashed) == compareCookie) {
        self._events(task, compareAtStore, true);

        return;
      }
      self._doAjax('get', task);
    });
};

/**
 * Вызов событий
 * @method
 * @private
 *
 * @param {Object} task - задача
 * @param {string} task.method - назание действия, которое пытаемся сделать
 * @param {boolean} fromInit - проверка, актуальны ли данные в сравнении или нужно обновлять
 */
Compare.prototype._events = function (task, products, fromInit) {
  let self = this;
  let data = self;

  // ставим новые данные в кеш если не актуален
  if (!fromInit) {
    Store.setItem('compare', data.products);
  }
  data.action = task;
  if (products) {
    data.products = products;
  }
  EventBus.publish(task.method + ':insales:compares', data);

  if (data.action.method != 'update_items' && data.action.method != 'overload') {
    EventBus.publish('update_items:insales:compares', data);
  }
};

/**
 * Событие ПЕРЕД действием
 * @method
 * @private
 */
Compare.prototype._before = function (task) {
  EventBus.publish('before:insales:compares', task);
};

/**
 * Мы закончили что-то делать в сравнении
 * @method
 * @private
 */
Compare.prototype._always = function (task) {
  EventBus.publish('always:insales:compares', task);
};

export default deferredSingletonExport(_Singleton(Compare), Compare);
